import React from "react";
import * as S from "./styles";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { IconButton } from "@mui/material";

function ScheduleBox({ machineId, schedule, handleDelete }) {
  return (
    <S.ScheduleBoxMchSch>
      <div style={{ flex: 1 }}>{schedule.displayText}</div>
      <div style={{ display: "flex", gap: "4px" }}>
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            handleDelete(machineId, {
              presetId: schedule.presetId,
              startDate: schedule.startDate,
              endDate: schedule.endDate,
            });
          }}
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
      </div>
    </S.ScheduleBoxMchSch>
  );
}

export default ScheduleBox;
